(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabbed-faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () {
          fn.apply(null, args);
        }, wait);
      };
    }

    function initCollectionDropdown(tabPanel) {
      if (tabPanel.dataset.collectionInitialized === 'true') return;
      tabPanel.dataset.collectionInitialized = 'true';

      var select = tabPanel.querySelector('.collection-select');
      var panelsWrap = tabPanel.querySelector('.collection-panels');
      var selectWrap = tabPanel.querySelector('.collection-select-wrap');
      if (!select || !panelsWrap) return;

      var panels = Array.prototype.slice.call(panelsWrap.children).filter(function (el) {
        return el.classList.contains('collection-panel');
      });
      if (!panels.length) {
        if (selectWrap) selectWrap.hidden = true;
        return;
      }

      // Build dropdown options from each Collection block's own label —
      // same reliable "read from the rendered element" pattern used for
      // the top-level tab buttons.
      panels.forEach(function (panel) {
        var opt = document.createElement('option');
        opt.value = panel.id;
        opt.textContent = panel.getAttribute('data-collection-label') || 'Collection';
        select.appendChild(opt);
      });

      // Hide the dropdown entirely if there's only one collection —
      // nothing to choose between.
      if (panels.length <= 1 && selectWrap) {
        selectWrap.hidden = true;
      }

      function showPanel(id) {
        panels.forEach(function (panel) {
          var match = panel.id === id;
          if (match) {
            panel.hidden = false;
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                panel.classList.add('is-visible');
              });
            });
          } else {
            panel.classList.remove('is-visible');
            panel.hidden = true;
          }
        });
      }

      showPanel(panels[0].id);
      select.value = panels[0].id;

      select.addEventListener('change', function () {
        showPanel(select.value);
      });
    }

    function initTabbedFaqs(root) {
      if (!root || root.dataset.tabsInitialized === 'true') return;
      root.dataset.tabsInitialized = 'true';

      var tabList = root.querySelector('.tabs-nav');
      var indicator = root.querySelector('.tabs-nav__indicator');
      var panelsWrap = root.querySelector('.tabs-panels');
      if (!tabList || !panelsWrap) return;

      var panels = Array.prototype.slice.call(panelsWrap.children).filter(function (el) {
        return el.classList.contains('tab-panel');
      });
      if (!panels.length) return;

      panels.forEach(function (panel) {
        var button = document.createElement('button');
        button.type = 'button';
        button.id = panel.id.replace('tab-panel-', 'tab-btn-');
        button.className = 'tabs-nav__item' + (panel.classList.contains('is-active') ? ' is-active' : '');
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', panel.classList.contains('is-active') ? 'true' : 'false');
        button.setAttribute('aria-controls', panel.id);
        button.setAttribute('tabindex', panel.classList.contains('is-active') ? '0' : '-1');
        button.setAttribute('data-tab-target', panel.id);
        button.textContent = panel.getAttribute('data-tab-label') || 'Tab';
        tabList.insertBefore(button, indicator);

        // Set up each tab's nested collection dropdown regardless of
        // whether the tab is currently visible, so it's ready the
        // moment the person switches to it.
        initCollectionDropdown(panel);
      });

      function getButtons() {
        return Array.prototype.slice.call(tabList.querySelectorAll('.tabs-nav__item'));
      }

      function isDesktop() {
        return window.innerWidth >= 990;
      }

      function moveIndicator(button) {
        if (!indicator || !button || !tabList) return;
        if (!isDesktop()) {
          indicator.style.opacity = 0;
          return;
        }
        var listRect = tabList.getBoundingClientRect();
        var btnRect = button.getBoundingClientRect();
        indicator.style.opacity = 1;
        indicator.style.width = btnRect.width + 'px';
        indicator.style.transform = 'translateX(' + (btnRect.left - listRect.left + tabList.scrollLeft) + 'px)';
      }

      function activateTab(targetButton, opts) {
        opts = opts || {};
        if (!targetButton) return;
        if (targetButton.classList.contains('is-active') && !opts.force) return;

        var buttons = getButtons();

        buttons.forEach(function (btn) {
          var active = btn === targetButton;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          btn.setAttribute('tabindex', active ? '0' : '-1');
        });

        var targetId = targetButton.getAttribute('data-tab-target');

        panels.forEach(function (panel) {
          if (panel.id === targetId) {
            panel.hidden = false;
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                panel.classList.add('is-visible');
              });
            });
          } else {
            panel.classList.remove('is-visible');
            panel.hidden = true;
          }
        });

        moveIndicator(targetButton);

        if (opts.scrollIntoView && !isDesktop()) {
          targetButton.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
        if (opts.focus) targetButton.focus();
      }

      root.addEventListener('click', function (e) {
        var button = e.target.closest ? e.target.closest('.tabs-nav__item') : null;
        if (!button || !root.contains(button)) return;
        activateTab(button, { scrollIntoView: true });
      });

      root.addEventListener('keydown', function (e) {
        var button = e.target.closest ? e.target.closest('.tabs-nav__item') : null;
        if (!button) return;

        var buttons = getButtons();
        var index = buttons.indexOf(button);
        if (index === -1) return;

        var newIndex = null;
        if (e.key === 'ArrowRight') newIndex = (index + 1) % buttons.length;
        else if (e.key === 'ArrowLeft') newIndex = (index - 1 + buttons.length) % buttons.length;
        else if (e.key === 'Home') newIndex = 0;
        else if (e.key === 'End') newIndex = buttons.length - 1;

        if (newIndex !== null) {
          e.preventDefault();
          activateTab(buttons[newIndex], { focus: true, scrollIntoView: true });
        }
      });

      var initialActive = getButtons().filter(function (b) {
        return b.classList.contains('is-active');
      })[0] || getButtons()[0];
      moveIndicator(initialActive);

      window.addEventListener(
        'resize',
        debounce(function () {
          var current = getButtons().filter(function (b) {
            return b.classList.contains('is-active');
          })[0];
          moveIndicator(current);
        }, 150)
      );

      root.addEventListener('shopify:block:select', function (event) {
        var panel = event.target.closest ? event.target.closest('.tab-panel') : null;
        if (panel) {
          var btn = getButtons().filter(function (b) {
            return b.getAttribute('data-tab-target') === panel.id;
          })[0];
          if (btn) activateTab(btn, { force: true });
        }

        var collectionPanel = event.target.closest ? event.target.closest('.collection-panel') : null;
        if (collectionPanel) {
          var parentTabPanel = collectionPanel.closest('.tab-panel');
          var select = parentTabPanel ? parentTabPanel.querySelector('.collection-select') : null;
          if (select && select.value !== collectionPanel.id) {
            select.value = collectionPanel.id;
            select.dispatchEvent(new Event('change'));
          }
        }
      });

      var animatedEls = root.querySelectorAll('[data-animate]');
      if (animatedEls.length) {
        if ('IntersectionObserver' in window) {
          var observer = new IntersectionObserver(
            function (entries, obs) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-inview');
                  obs.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
          );
          animatedEls.forEach(function (el) {
            observer.observe(el);
          });
        } else {
          animatedEls.forEach(function (el) {
            el.classList.add('is-inview');
          });
        }
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.tabbed-faqs').forEach(function (root) {
        initTabbedFaqs(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
